import Types from "../../constants/Types.js";
export default {
  name: 'type',
  objectType: Types.firmwareRelease,
  valueType: 'string',
  get: (data, cxt) => {
    return data?.type;
  },
  set: (data, value, cxt) => {
    return {
      ...data,
      type: value
    };
  },
  canSet: () => true,
  getPatch: (data, value, cxt) => {
    return {
      path: 'type',
      value
    };
  },
  getDefaultValue: () => 'production',
  displayName: 'Type',
  source: {
    type: Types.apiName,
    editable: false,
    creatable: true,
    createOptions: {
      editor: 'enum',
      editorProps: {
        get values() {
          return [{
            value: 'production',
            name: 'Production'
          }, {
            value: 'beta',
            name: 'Beta'
          }];
        }
      }
    }
  }
};